import React from 'react';

import styles from './dropdown-indicator.module.scss';

export default function DropdownIndicator() {
  return (
    <span className={styles['dropdown-indicator']} />
  );
}
